import { useTranslation } from 'react-i18next'
import { useMerchantIdFromSubdomain } from '../containers/ApplicationForm/hooks'
import { B2C_MERCHANT_IDS, Constants } from '../types/constants'

export default function useFaqLink() {
  const { i18n } = useTranslation()
  const baseUrl = Constants.Host?.Ifinance || 'https://ifinancecanada.com'
  const merchantId = useMerchantIdFromSubdomain()
  const languagePrefix = i18n.language === 'fr' ? '/fr' : ''
  if (merchantId === B2C_MERCHANT_IDS.circlek) return `${baseUrl}${languagePrefix}/faq/circlek`

  return `${baseUrl}${languagePrefix}/faq/neo`
}
